import type { Game } from '../../game/Game';
import type { Actor } from '../../sim/actor';
import { bondNpcs } from './data';
import { claimStageRewards } from './logic';

/** Game-side glue for Bonds and emotes. */

export const bondsGame: { current: Game | null } = { current: null };

/** The NPC's actor when they are in the current zone, with their distance to the player. */
export function npcPresence(game: Game, npc: string): { actor: Actor; dist: number } | null {
  const z = game.zone;
  const p = game.player;
  if (!z || !p) return null;
  for (const a of z.world.actors.values()) {
    if (a.kind === 'npc' && a.npcId === npc) return { actor: a, dist: Math.hypot(a.pos.x - p.pos.x, a.pos.z - p.pos.z) };
  }
  return null;
}

let acc = 0;

/**
 * Bond points also come from quests and the dialogue's "share a moment"
 * option; this catches up on stage rewards (cards, gifts, titles) whatever
 * the source.
 */
export function bondRewardSystem(game: Game, dt: number): void {
  acc += dt;
  if (acc < 0.5) return;
  acc = 0;
  const prog = game.progression;
  if (!prog) return;
  let any = false;
  for (const npc of bondNpcs()) if (claimStageRewards(prog, npc).length) any = true;
  if (any) game.store.saveSoon(game.account);
}
